module.exports = __webpack_public_path__ + "static/media/08.aff456e0.jpg";